/**
 * @generated SignedSource<<4e18540dbc80c51f57f4b1a864cf2dba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EnterReportDraftInput = {
  reportId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type EnterReportDraftMutation$variables = {
  input: EnterReportDraftInput;
};
export type EnterReportDraftMutation$data = {
  readonly enterReportDraft: {
    readonly draftState: string | null;
    readonly publishedAt: string | null;
    readonly locked: boolean | null;
    readonly draftFilterWillRevert: boolean | null;
  } | null;
};
export type EnterReportDraftMutation = {
  variables: EnterReportDraftMutation$variables;
  response: EnterReportDraftMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EnterReportDraftPayload",
    "kind": "LinkedField",
    "name": "enterReportDraft",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "draftState",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publishedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locked",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "draftFilterWillRevert",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EnterReportDraftMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EnterReportDraftMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b5977dbc0034803325ef56a36e1dd587",
    "id": null,
    "metadata": {},
    "name": "EnterReportDraftMutation",
    "operationKind": "mutation",
    "text": "mutation EnterReportDraftMutation(\n  $input: EnterReportDraftInput!\n) {\n  enterReportDraft(input: $input) {\n    draftState\n    publishedAt\n    locked\n    draftFilterWillRevert\n  }\n}\n"
  }
};
})();

(node as any).hash = "30f59d077a123675d3792cf2db4f5010";

export default node;
